import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  INSERT_VARIABLE_BUTTON: `${cleanedFilename(
    __filename,
  )}-insert-variable-button`,
};
